export const vendorsConstants = {
  KIND_VENDOR: "1",
  KIND_PARTNER: "2",
  KIND_DISTRIBUTOR: "3",

  TYPE_SOFTWARE: "1",
  TYPE_HARDWARE: "2",
  TYPE_CONSULTANT: "3",
};
